import { bool, func, number } from 'prop-types'
import Button from '../../Button'
import { noPropagate } from '../../utils'

const DeleteButton = ({ onDelete, current, selected, editable, label }) => {
  if (current && selected && editable && !label) {
    return (
      <Button
        onClick={noPropagate(onDelete)}
        tooltip="Discard Draft"
        themeClass="light"
        icon="delete"
        type="invisible"
      />
    )
  }
  return null
}

DeleteButton.propTypes = {
  current: bool,
  editable: bool,
  label: number,
  onDelete: func,
  selected: bool,
}

export default DeleteButton
